export const getSeo = (seo: any) => {
  if (!seo) {
    return {}
  }
  const { seo_description, seo_title, seo_image } = seo
  return { seo_description, seo_title, seo_image }
}
